import { Route, Routes } from "react-router-dom";
import AuthenticationLoginPage from "./authentication/AuthenticationLoginPage";
import AuthenticationForgotPasswordPage from "./authentication/AuthenticationForgotPassword";

const RoutesAuth = () => {
  return (
    <Routes>
      <Route path="/" element={<AuthenticationLoginPage />} />
      <Route path="/forgot-password" element={<AuthenticationForgotPasswordPage />} />
    </Routes>
  );
};

export default RoutesAuth;